import React, { useState, useEffect } from 'react';

const formatFunctions = {
  cpf: value => {
    const numbers = value.replace(/\D/g, '').slice(0, 11); // CPF tem 11 dígitos
    return {
      formatted: numbers
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2'),
      raw: numbers
    };
  },
  rg: value => {
    const numbers = value.replace(/\D/g, '');
    return {
      formatted: numbers,
      raw: numbers
    };
  },
  cep: value => {
    const numbers = value.replace(/\D/g, '').slice(0, 8); // CEP tem 8 dígitos
    return {
      formatted: numbers.replace(/^(\d{5})(\d)/, '$1-$2'),
      raw: numbers
    };
  },
  telefone: value => {
    const numbers = value.replace(/\D/g, '').slice(0, 11); // Limite para até 11 dígitos
    return {
      formatted: numbers
        .replace(/^(\d{2})(\d)/, '($1) $2') // Formata o código de área entre parênteses
        .replace(/(\d{5})(\d{4})$/, '$1-$2'), // Divide os 9 dígitos em 5 e 4 com um hífen
      raw: numbers
    };
  },
  nome: value => {
    // Tira só o acento e mantém a letra (JOÃO -> JOAO, conceição -> CONCEICAO).
    const upperCaseText = value
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .toUpperCase();
    return {
      formatted: upperCaseText,
      raw: upperCaseText
    };
  }
};

function FormattedInput({ id, type, placeholder, value, onChange, name }) {
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    setDisplayValue(value ? formatFunctions[type]?.(value)?.formatted : '');
  }, [value, type]);

  const handleChange = event => {
    const inputValue = event.target.value;
    const formatter = formatFunctions[type];
    const { formatted, raw } = formatter ? formatter(inputValue) : { formatted: inputValue, raw: inputValue };

    setDisplayValue(formatted); // Atualiza o valor exibido
    // Aqui enviamos o valor formatado para a API se o tipo for "cpf".
    const valueToSend = type === 'cpf' ? formatted : raw;
    onChange({ target: { name, value: valueToSend, type: 'text' } });
  };

  return (
    <input
      id={id}
      type="text"
      name={name}
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
    />
  );
}

export default FormattedInput;